import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getSimulate, getToken, setSimulate, setToken } from "../lib/api";

const Ctx = createContext(null);
const SIM_KEY = "ptr_simulate_user";

export function AuthProvider({ children }) {
  const [realUser, setRealUser] = useState(null);
  const [simUser, setSimUser] = useState(() => { try { return getSimulate() ? JSON.parse(localStorage.getItem(SIM_KEY)) : null; } catch { return null; } });
  const [reportTypes, setReportTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const d = await api("/auth/me");
    if (getSimulate()) setReportTypes(d.report_types || []);
    else { setRealUser(d.user); setReportTypes(d.report_types || []); }
    return d;
  }, []);

  useEffect(() => {
    (async () => {
      if (getToken()) {
        const sim = getSimulate();
        setSimulate(null);
        for (let i = 0; i < 8; i += 1) {
          try { await loadMe(); break; } catch (e) {
            if (e.status === 401 || e.status === 403) { setToken(null); break; }
            await new Promise((r) => setTimeout(r, 8000));
          }
        }
        if (sim) { setSimulate(sim); try { await loadMe(); } catch {} }
      }
      setLoading(false);
    })();
  }, [loadMe]);

  const stopSimulation = useCallback(async () => {
    setSimulate(null); localStorage.removeItem(SIM_KEY); setSimUser(null);
    try { await loadMe(); } catch {}
  }, [loadMe]);

  const startSimulation = async (target) => {
    setSimulate(target.id); localStorage.setItem(SIM_KEY, JSON.stringify(target)); setSimUser(target);
    try { await loadMe(); } catch {}
  };

  const finish = async (d) => {
    if (d.device_token) localStorage.setItem("crew_device", d.device_token);
    setToken(d.token);
    setRealUser(d.user);
    await loadMe();
  };
  const signIn = async (email, password) => {
    setSimulate(null); localStorage.removeItem(SIM_KEY); setSimUser(null);
    const d = await api("/auth/login", { method: "POST", body: { email, password } });
    if (d.twofa_required) return d;
    await finish(d);
    return null;
  };
  const verifyCode = async (challenge_id, code, remember) => {
    await finish(await api("/web/2fa/verify", { method: "POST", body: { challenge_id, code, remember } }));
  };
  const signOut = () => { setSimulate(null); localStorage.removeItem(SIM_KEY); setSimUser(null); setToken(null); setRealUser(null); setReportTypes([]); };
  const refresh = async () => { try { await loadMe(); } catch {} };
  const user = realUser && simUser ? simUser : realUser;

  return <Ctx.Provider value={{ user, realUser, simulating: !!(realUser && simUser), startSimulation, stopSimulation, reportTypes, loading, signIn, verifyCode, signOut, refresh }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
